import React from 'react';
import { Sheet } from '@amzn/storm-ui';
import { MobileNavSheetInnerContainer } from './styles';

/**
 * This component handles the container formatting
 * logic of components that are rendered in the Sheet
 * StormUI component
 */

// there are some typing issues with storm ui components and the following
// eslint disable rule is needed

type MobileNavSheetProps = React.ComponentProps<typeof Sheet> & {
  hasInnerPadding?: boolean;
  // Passed by callers but not part of SheetProps; forwarded via `...sheetProps`
  // (unused by Sheet). Kept so existing call sites keep compiling. See FINDINGS.
  type?: string;
};

export const MobileNavSheet = ({
  children,
  hasInnerPadding = true,
  closeButton,
  ...sheetProps
}: MobileNavSheetProps) => {
  return (
    <Sheet {...sheetProps} closeButton={closeButton} padding="none">
      <MobileNavSheetInnerContainer hasInnerPadding={hasInnerPadding}>
        {children}
      </MobileNavSheetInnerContainer>
    </Sheet>
  );
};
